exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea, input {\n  width:600px;\n}\n\ntextarea {\n  min-height: 6ex;\n}\n\ntextarea.abstract {\n  min-height:15ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-db-record-box/edit-db-record-box.component.css
// module id = 387
// module chunks = 0